/* eslint-disable @typescript-eslint/naming-convention */
import { type IService } from '../../shared';
import type { ServiceManager } from '../service-manager';
import { ClipboardHotkey } from './clipboard';

export interface IHotkeyItem {
    /** 快捷键类型 */
    key: string;
    /** 快捷键名称 */
    name: string;
    /** 快捷键 Windows 菜单显示文本 */
    win: string;
    /** 快捷键 Mac 菜单显示文本 */
    mac: string;
    /** 是否忽略禁用图层选择 */
    ignoreDisablePick?: boolean;
    /** 按键处理器 */
    processors?: {
        /** 按键组合 */
        press: string[];
        /** 处理函数 */
        fn: () => void;
    }[];
}

export class HotkeyService extends ClipboardHotkey implements IService {
    constructor(readonly service: ServiceManager) {
        super(service);
    }

    onInit() {}

    onMount() {
        super.mount();
    }

    onUnmount() {
        super.unmount();
    }
}
